import { useEffect, useRef, useState } from "react";
import { Pause, Play, X, Loader2 } from "lucide-react";
import { audioUrl } from "@/lib/api";

const fmt = (s) => (isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}` : "0:00");
const RATES = [1, 1.25, 1.5, 2];

export function AudioPlayer({ a, onClose }) {
  const ref = useRef(null);
  const [state, setState] = useState("loading");
  const [t, setT] = useState(0);
  const [dur, setDur] = useState(0);
  const [rate, setRate] = useState(1);

  useEffect(() => { const el = ref.current; el.play().catch(() => {}); }, []);
  useEffect(() => { ref.current.playbackRate = rate; }, [rate]);
  const playing = state === "playing";
  const toggle = () => (playing ? ref.current.pause() : ref.current.play());

  return (
    <div data-testid="audio-player" className="rise fixed inset-x-3 bottom-20 z-50 mx-auto max-w-2xl rounded-2xl bg-foreground p-3 text-background shadow-2xl lg:bottom-6">
      <audio ref={ref} src={audioUrl(a.id)} preload="auto"
        onPlaying={() => setState("playing")} onPause={() => setState("paused")} onWaiting={() => setState("loading")}
        onError={() => setState("error")} onTimeUpdate={(e) => setT(e.target.currentTime)} onLoadedMetadata={(e) => setDur(e.target.duration)} onEnded={() => setState("paused")} />
      <div className="flex items-center gap-3">
        <button data-testid="audio-play-pause-btn" onClick={toggle} disabled={state === "loading" || state === "error"} className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-primary text-white">
          {state === "loading" ? <Loader2 size={18} className="animate-spin" /> : playing ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
        </button>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <div className="flex h-3 items-end gap-[2px]">{[0, 1, 2, 3].map((i) => <span key={i} className={`w-[3px] rounded bg-primary ${playing ? "wave-bar" : ""}`} style={{ height: "100%", animationDelay: `${i * 0.15}s`, transform: playing ? undefined : "scaleY(.35)" }} />)}</div>
            <p data-testid="audio-status" className="truncate text-xs font-semibold">
              {state === "loading" ? "A preparar o áudio da notícia…" : state === "error" ? "Áudio indisponível" : a.title}
            </p>
          </div>
          <div className="mt-1.5 flex items-center gap-2 font-mono-meta text-[10px] opacity-70">
            <span>{fmt(t)}</span>
            <input data-testid="audio-seek" type="range" min={0} max={dur || 0} step={0.1} value={t} onChange={(e) => { ref.current.currentTime = +e.target.value; }} className="h-1 flex-1 accent-red-600" />
            <span>{fmt(dur)}</span>
          </div>
        </div>
        <button data-testid="audio-rate-btn" onClick={() => setRate(RATES[(RATES.indexOf(rate) + 1) % RATES.length])} className="rounded-full border border-background/30 px-2.5 py-1 font-mono-meta text-[11px] font-bold">{rate}x</button>
        <button data-testid="audio-close-btn" onClick={onClose} className="opacity-60 hover:opacity-100" aria-label="Fechar"><X size={18} /></button>
      </div>
    </div>
  );
}
